<template>
  <div class="mcp3">
    <div class="mcp3-title1">WE ARE NOW</div>
    <div class="mcp3-title2">Live Commerce Platform</div>
    <div class="mcp3-description">
      “ON STYLE LIVE” 는 5G와 AI기술을 바탕으로 한
      라이브 방송 + 쇼핑이 결합된 통합 라이브 커머스 플랫폼 서비스입니다.
    </div>
    <div class="cont-img">
      <img src="@/assets/mcp3-img.png" alt />
    </div>
    <div class="cont-list">
      <ul>
        <li>WebRTC &#38; AdaPtive Bitrate Live Streaming</li>
        <li>AWCS(Advanced Web Crawling System)</li>
        <li>AUBRS(Advanced User Based Recommendation System)</li>
        <li>Cloud Server Service</li>
        <li>Socket.io &#38; Redis Chatting Service</li>
        <li>N-screen Service</li>
      </ul>
    </div>
    <div class="mcp3-btn">
      <router-link to="/product" class="mcp3-link">ON STYLE LIVE 알아보기</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "MCompanyPart3"
};
</script>
<style lang="scss" scoped>
.mcp3 {
  width: 100%;
  // padding: 20px 20px 30px 20px;
  // box-sizing: border-box;
  position: relative;

  .mcp3-title1 {
    font-size: 16px;
    color: #a1a1a1;
    text-align: center;
    margin-bottom: 10px;
  }

  .mcp3-title2 {
    font-size: 20px;
    font-weight: 900;
    color: #00a79d;
    text-align: center;
    margin-bottom: 10px;
  }

  .mcp3-description {
    font-size: 16px;
    color: #a1a1a1;
    text-align: center;
    padding: 20px 20px 30px 20px;
    box-sizing: border-box;
    margin-bottom: 50px;
  }

  .cont-img {
    width: 100%;
    padding: 50px 0px 50px 0px;
    background-color: #bfdfd9;
    position: relative;
    text-align: center;
    margin-bottom: 30px;

    img {
      width: 60%;
    }
  }

  .cont-list {
    margin-bottom: 50px;

    li {
      color: #a1a1a1;
    }
  }

  .mcp3-btn {
    width: 100%;
    text-align: center;
    margin-bottom: 50px;

    .mcp3-link {
      text-decoration: none;
      color: #fff;
      font-size: 16px;
      padding: 15px 50px;
      background-color: #00a79d;
      border-radius: 30px;
    }
  }
}
</style>